import { MakeCall, MakeCallPromise } from './createMakeCall';
import { MyUserInfoApiV2, UserInformation } from './types/UserInformation';

export interface Query {
  expand: string;
  // This will force the request to reach the write replica. In case of doubt, don't use it.
  initial?: boolean;
}

const getUserInformation = (makeCall: MakeCall) => {
  function getUserInformationCall(
    id: 'me',
    query?: Query,
  ): MakeCallPromise<MyUserInfoApiV2>;
  function getUserInformationCall(
    id: number,
    query?: Query,
  ): MakeCallPromise<UserInformation>;
  function getUserInformationCall(id: number | 'me' = 'me', query?: Query) {
    return makeCall('GET', `/api/v2/user/${id}/information`, { query });
  }

  return getUserInformationCall;
};

export { getUserInformation };
